// initial state
const state = {
  open: false
}

// mutations
const mutations = {
  toggleMenu () {
    state.open = !state.open
  },
  closeMenu () {
    state.open = false
  }
}


export default {
  namespaced: true,
  state,
  mutations
}